export enum ArtistTypes {
    ARTIST = 0,
    ARTIST_SETLIST = 1,
    NULL = 2
}